module.exports = __webpack_public_path__ + "static/img/01.6741580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/peterschmid/01.jpg
// module id = 435
// module chunks = 1